(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
	const announcementHeight = () => {
		// Select all elements
		const announcements = document.querySelectorAll(
			'.shopify-section-group-header-group.section-announcement'
		);

		if (announcements.length === 0) {
			return;
		}

		// Initialize the variable to store the total height
		let announcementHeight = 0;

		// Iterate over each element and add its height to the total
		announcements.forEach((announcement) => {
			const height = announcement.offsetHeight; // Get the height of the element
			announcementHeight += height; // Add it to the total
		});

		document.documentElement.style.setProperty(
			'--announcement-height',
			`${announcementHeight}px`
		);
		return announcementHeight;
	};

	announcementHeight();

	const iconClose = () => {
		const icons = document.querySelectorAll(".icon-close");
		icons.forEach((icon) => {
			icon.addEventListener("click", function () {
				const announcement = icon.closest(".section-announcement");
				if (announcement) {
					announcement.style.display = "none";
				}
				announcementHeight();
			});
		});
	};

	iconClose();

	document.addEventListener('shopify:section:load', function () {
		announcementHeight();
		iconClose();
	});
	window.addEventListener('resize', announcementHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerOverlay = document.querySelector('.header-overlay');
		const headerOverlayWithBackground = document.querySelector('[data-overlay-with-background]')?.dataset.overlayWithBackground === 'true';
		
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;

		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-sticky','always-fixed');
			if (this.headerOverlay && headerOverlayWithBackground) {
				//this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}			
			if (this.headerOverlay && !headerOverlayWithBackground) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		};

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	const isBurgerMenuActive = document.querySelector('.burger-drawer.active');
	if (isBurgerMenuActive) return;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
			requestAnimationFrame(this.reveal.bind(this));
			}else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		const headerOverlayWithBackground = document.querySelector('[data-overlay-with-background]')?.dataset.overlayWithBackground === 'true';

		if (document.querySelector(".search-modal.active")) return;
		if (document.querySelector(".header__account.active")) return;
		if (document.querySelector(".burger-drawer.active")) return;
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		if (this.headerOverlay && !headerOverlayWithBackground ) {
			this.headerOverlay.classList.add('color-background-1');
		}
	}

	reveal() {
		const headerOverlayWithBackground = document.querySelector('[data-overlay-with-background]')?.dataset.overlayWithBackground === 'true';

		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-inverse');
		if (this.headerOverlay && headerOverlayWithBackground) {
			//this.headerOverlay.classList.add('color-background-1');
			this.headerOverlay.classList.remove('color-inverse');
		}
		if (this.headerOverlay && !headerOverlayWithBackground) {
			this.headerOverlay.classList.add('color-background-1');
			this.headerOverlay.classList.remove('color-inverse');
		}

		if (document.querySelector(".shopify-section-header .scroll_color")) {
        const backgroundElements = this.header.querySelectorAll(".header-top-background");

        backgroundElements.forEach((element) => {
            if (!element.dataset.originalClass) {
                element.classList.forEach((className) => {
                    if (className.startsWith("color-background-")) {
                        element.dataset.originalClass = className;
                        element.classList.remove(className);
                    }
                });
            }
            element.classList.add("color-background-1");
        });
    }
	}

	reset() {
		const headerOverlayWithBackground = document.querySelector('[data-overlay-with-background]')?.dataset.overlayWithBackground === 'true';

		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.headerOverlay && headerOverlayWithBackground) {
			//this.headerOverlay.classList.remove('color-background-1');
			this.headerOverlay.classList.add('color-inverse');
		}		
		if (this.headerOverlay && !headerOverlayWithBackground) {
			this.headerOverlay.classList.remove('color-background-1');
			this.headerOverlay.classList.add('color-inverse');
		}

		if (document.querySelector(".shopify-section-header .scroll_color")) {
			const backgroundElements = this.header.querySelectorAll(".header-top-background");
			backgroundElements.forEach((element) => {
					element.classList.remove("color-background-1");

					if (element.dataset.originalClass) {
							element.classList.add(element.dataset.originalClass);
							delete element.dataset.originalClass;
					}
			});
		}
	}

	//closeMenuDisclosure() {
	//	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	//	this.disclosures.forEach(disclosure => disclosure.close());
	//}

	}

	customElements.define('sticky-header', StickyHeader);	
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
		}
		
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
					const initSlider = () => {
						document
							.querySelectorAll(".js-recommendation-swiper")
							.forEach((elem, index) => {
								let slider = new Swiper(elem, {
									slidesPerView: 1,
									spaceBetween: 0,
									speed: 600,
									navigation: {
										nextEl: elem.querySelector(
											".product-recommendations__slider-nav .swiper-button-next"
										),
										prevEl: elem.querySelector(
											".product-recommendations__slider-nav .swiper-button-prev"
										),
									},
								});
							});
					};
					initSlider()
				})
				.catch(e => {
					console.error(e);
				});
				
		}
		
		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}

						const initProductSlider = () => {
							var swiper = new Swiper('.swiper-container', {
								slidesPerView: 1,

								spaceBetween: 0,
								navigation: {
									nextEl: '.product-button-group .swiper-button-next-1',
									prevEl: '.product-button-group .swiper-button-prev-1',
								},
							});
						};

						initProductSlider();
						buttonHoverEffects();
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
